var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetherlands({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_100836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 1.03219C22.3139 1.03266 22.6743 1.1659 22.9401 1.4027C23.2059 1.63949 23.3555 1.96052 23.356 2.2954V20.0015C23.3555 20.3364 23.2059 20.6574 22.9401 20.8942C22.6743 21.131 22.3139 21.2642 21.938 21.2647H2.06201C1.6861 21.2642 1.32572 21.131 1.05991 20.8942C0.7941 20.6574 0.644523 20.3364 0.643994 20.0015V2.2954C0.644523 1.96052 0.7941 1.63949 1.05991 1.4027C1.32572 1.1659 1.6861 1.03266 2.06201 1.03219H21.938ZM21.938 0.458496H2.06201C1.5153 0.458968 0.991126 0.652658 0.604541 0.997039C0.217956 1.34142 0.000529505 1.80837 0 2.2954V20.0015C0.000529505 20.4885 0.217956 20.9555 0.604541 21.2999C0.991126 21.6442 1.5153 21.8379 2.06201 21.8384H21.938C22.4845 21.8375 23.0084 21.6436 23.3949 21.2993C23.7813 20.9551 23.9989 20.4884 24 20.0015V2.2954C23.9995 1.80837 23.782 1.34142 23.3955 0.997039C23.0089 0.652658 22.4847 0.458968 21.938 0.458496Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.356 7.58496H0.643951V14.7116H23.356V7.58496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9379 1.03223H2.06197C1.68605 1.0327 1.32568 1.16595 1.05987 1.40274C0.794057 1.63953 0.644481 1.96056 0.643951 2.29544V7.58518H23.356V2.29544C23.3554 1.96056 23.2059 1.63953 22.94 1.40274C22.6742 1.16595 22.3139 1.0327 21.9379 1.03223Z",
    fill: "#CA1725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643951 20.0017C0.644481 20.3365 0.794057 20.6576 1.05987 20.8944C1.32568 21.1311 1.68605 21.2644 2.06197 21.2649H21.9379C22.3139 21.2644 22.6742 21.1311 22.94 20.8944C23.2059 20.6576 23.3554 20.3365 23.356 20.0017V14.7119H0.643951V20.0017Z",
    fill: "#00458D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_100836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3799,
    fill: "white",
    transform: "translate(0 0.458496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetherlands);
export default __webpack_public_path__ + "static/media/Netherlands.6cea9cf4296dbc8f4bb3d2f0cf906f2c.svg";
export { ForwardRef as ReactComponent };